import computed from './computed'
import data from './data'
import components from './components'
import mounted from './mounted'

export default {
  computed,
  data,
  components,
  mounted,
  resourcePath: '/v1/dweller/book/occurrence'
}



// WEBPACK FOOTER //
// ./src/app/tenant/book-occurrence/resources/index.js